/**
* Instafeed JS
* -----------------------------------------------------------------------------
*
* All the JS for the Instafeed component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'instafeed',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const instaUpdates = ( feed, instaHandle ) => {
        if ( feed.length === 0 ) return;
        feed.find( '.sbi_item' ).each( function( index, element ) {
          const photoWarp = $( element ).find( '.sbi_photo_wrap' );
          if ( photoWarp.length ) {
            const hoverText = `<span class="absolute inset-0 instafeed__overlay"></span><p class="instafeed__hover-text"><span class="uppercase hdg-1 mb-6">Follow Us</span><span class="insta_handle paragraph-small">${instaHandle}</span></p>`;
            photoWarp.append( hoverText );
          }
          const img = $( element ).find( 'img' );
          const screenReaderText = $( element ).find( 'a .sbi-screenreader' );
          const imgAlt = img.attr( 'alt' );
          screenReaderText.text( `View full post about ${imgAlt} (opens in new tab)` );
          // image should be purely decorative since its a function image in a link
          img.attr( 'alt', '' );
        } );
      };
      $( '.instafeed' ).each( function( index, element ) {
        const feed = $( element ).find( '#sb_instagram' );
        const instaHandle = $( element ).attr( 'data-insta' );

        instaUpdates( feed, instaHandle );

        /* apply custom js after load more button has been clicked s*/
        window.sbi_custom_js = function() {
          instaUpdates( feed, instaHandle );
        };
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'instafeed', COMPONENT );
} )( app );
